import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  constructor(private dataService: DataService) { }

  getFeatures(page: number, size: number) {
    return this.dataService.getFeatures(page, size);
  }

  toggleFeatureEnabled(id: number, enabled: boolean) {
    return this.dataService.toggleFeatureEnabled(id, enabled);
  }
}
